export const nav = {
    content: {
        moreLink: '//www.ifeng.com/daohang/',
        nav: [
            {
                title: '首页',
                url: '//www.ifeng.com/',
            },
            {
                title: '资讯',
                url: '//news.ifeng.com/',
            },
            {
                title: '视频',
                url: '//v.ifeng.com/',
            },
            {
                title: '直播',
                url: '//zhibo.ifeng.com/',
            },
            {
                title: '财经',
                url: '//finance.ifeng.com/',
            },
            {
                title: '娱乐',
                url: '//ent.ifeng.com/',
            },
            {
                title: '体育',
                url: '//sports.ifeng.com/',
            },
            {
                title: '时尚',
                url: '//fashion.ifeng.com/',
            },
            {
                title: '汽车',
                url: '//auto.ifeng.com/',
            },
            {
                title: '房产',
                url: '//house.ifeng.com/',
            },
            {
                title: '科技',
                url: '//tech.ifeng.com/',
            },
            {
                title: '读书',
                url: '//book.ifeng.com/',
            },
            {
                title: '文化',
                url: '//culture.ifeng.com/',
            },
            {
                title: '历史',
                url: '//history.ifeng.com/',
            },
            {
                title: '军事',
                url: '//mil.ifeng.com',
            },
            {
                title: '旅游',
                url: '//travel.ifeng.com/',
            },
            {
                title: '佛教',
                url: '//fo.ifeng.com/',
            },
            {
                title: '国学',
                url: '//guoxue.ifeng.com/',
            },
            {
                title: '数码',
                url: '//tech.ifeng.com/digi/',
            },
            {
                title: '健康',
                url: '//health.ifeng.com/',
            },
            {
                title: '家居',
                url: '//home.ifeng.com/',
            },
            {
                title: '彩票',
                url: '//cp.ifeng.com/?aid=45',
            },
            {
                title: '公益',
                url: '//gongyi.ifeng.com/',
            },
            {
                title: '酒业',
                url: '//jiu.ifeng.com/',
            },
        ],
        limit: 18,
    },
};

export const footer = {
    content: [
        {
            title: '凤凰新媒体介绍',
            url: '//www.ifeng.com/corp/about/intro/',
        },
        {
            title: '投资者关系 Investor Relations',
            url: '//ir.ifeng.com/',
        },
        {
            title: '广告服务',
            url: '//biz.ifeng.com/',
        },
        {
            title: '诚征英才',
            url: '//career.ifeng.com/',
        },
        {
            title: '保护隐私权',
            url: '//www.ifeng.com/corp/privacy/',
        },
        {
            title: '免责条款',
            url: '//www.ifeng.com/corp/exemption/',
        },
        {
            title: '意见反馈',
            url: '//www.ifeng.com/corp/feedback/',
        },
        {
            title: '凤凰卫视介绍',
            url: '//phtv.ifeng.com/intro/',
        },
        {
            text0: '凤凰新媒体',
            text1: '版权所有',
            text2: 'Copyright © 2016 Phoenix New Media Limited All Rights Reserved.',
        },
    ],
};

export const banner = {
    bannerLogo: `<a href="http://finance.ifeng.com/" target="_blank" title="理财首页">
    <img src="//p1.ifengimg.com/l/2017/46/4719d5ca969ad69/headLogo_finance.png" width="161" height="27" alt="凤凰网" />
</a>`,
    search: [
        { type: 'sofeng', name: '站内', keyword: '' },
        { type: 'hq', name: '证券', keyword: '上证指数' },
        { type: 'car', name: '汽车', keyword: '输入品牌或车系' },
        { type: 'video', name: '视频', keyword: '' },
    ],
};
